import { comparePolicies } from "./comparePolicies";
import { deriveOsapProfile } from "./deriveOsapProfile";
import { calculateRepayment } from "./calculateRepayment";
import { validateStudentProfile } from "./validation";
import { StudentProfile, RepaymentResult } from "./types";
import { estimateEducationCosts } from "./estimateEducationCosts";
import { PRE_2026_POLICY } from "./policyVersions";

export interface DebtCalculationResult {
  isValid: boolean;
  errors: string[];
  costs: ReturnType<typeof estimateEducationCosts> | null;
  comparison: ReturnType<typeof comparePolicies> | null;
  repayment: {
    pre2026: RepaymentResult | null;
    post2026: RepaymentResult | null;
  };
}

export function runDebtCalculation(
  profile: StudentProfile
): DebtCalculationResult {
  const validation = validateStudentProfile(profile);

  if (!validation.isValid) {
    return {
      isValid: false,
      errors: validation.errors,
      costs: null,
      comparison: null,
      repayment: {
        pre2026: null,
        post2026: null,
      },
    };
  }

  const normalizedProfile = deriveOsapProfile(profile);

  const costs = estimateEducationCosts(normalizedProfile, PRE_2026_POLICY);
  const comparison = comparePolicies(normalizedProfile);

  const pre2026Repayment = calculateRepayment(comparison.pre2026.loans);
  const post2026Repayment = calculateRepayment(comparison.post2026.loans);

  return {
    isValid: true,
    errors: [],
    costs,
    comparison,
    repayment: {
      pre2026: pre2026Repayment,
      post2026: post2026Repayment,
    },
  };
}